// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".headline[data-v-726ba07e]{text-align:center;margin-bottom:50px;width:100%;text-transform:uppercase;margin-top:40px}@media(max-width:960px){.headline[data-v-726ba07e]{margin-bottom:15px}}", ""]);
// Exports
module.exports = exports;
